<template>
  <div v-if="applicantProfile" id="applicant-show-tab-cv">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="applicant-show-form">
          <CvForm
            v-model="applicantProfile.cvEntries"
            @add-entry="addEntry"
            @update-entry="editEntry"
            @sort-entries="sortEntries"
            @refetch="refetch"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import salutations from "@/data/enums/Salutation.js";
import salutationTypes from "@/data/enums/SalutationType.js";
import civilStates from "@/data/enums/CivilStatus.js";
import CvForm from "../form/CV";

export default {
  components: {
    CvForm
  },
  props: {
    profileId: {
      type: String,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      salutations,
      salutationTypes,
      civilStates,
      fetchFailed: false,
      refetchTimeout: null
    };
  },
  apollo: {
    applicantProfile: {
      query: gql`
        query ApplicantProfile($id: ID!) {
          applicantProfile(id: $id) {
            id
            cvEntries {
              id
              type {
                id
                name
              }
              branch {
                id
                name
              }
              dateUntil
              dateFrom
              employer
              position
              description
              sort
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          id: this.profileId
        };
      }
    }
  },
  methods: {
    refetch() {
      this.$apollo.queries.applicantProfile.refetch();
    },
    sortEntries() {
      this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!) {
            sortCvEntries(profile: $id)
          }
        `,
        variables: {
          id: this.profileId
        },
        update: () => {
          this.$apollo.queries.applicantProfile.refetch();
        }
      });
    },
    async addEntry(input) {
      input.applicant = this.$route.params.id;
      input.applicantProfileID = this.profileId;

      await this.$apollo.mutate({
        mutation: gql`
          mutation($input: CvEntryInput!) {
            createCvEntry(input: $input) {
              id
            }
          }
        `,
        variables: {
          input
        }
      });

      this.$apollo.queries.applicantProfile.refetch();
    },
    async editEntry(val) {
      let input = JSON.parse(JSON.stringify(val));
      input.applicant = this.$route.params.id;
      input.applicantProfileID = this.profileId;
      input.type = input.type && input.type.id ? input.type.id : input.type;
      input.branch =
        input.branch && input.branch.id ? input.branch.id : input.branch;

      await this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!, $input: CvEntryInput!) {
            updateCvEntry(id: $id, input: $input) {
              id
              sort
            }
          }
        `,
        variables: {
          id: input.id,
          input: Object.prepareGqlInput(input, ["applicantProfile"])
        }
      });
    }
  }
};
</script>
